import React from "react";
import "./hero.css";
import { Btn } from "../../utils/utils";
import hero from "../../assets/hero.png";
// import SearchFilter from "../search-filter/SearchFilter";

const Hero = () => {
  return (
    <div className="hero">
      <div className="hero-head">
        <div className="hero-left">
          <h1>
            Find the Pro<span>perty</span> that <span>Fits</span> Your Vi
            <span>sion </span>Today!
          </h1>
          <p>
            Connecting You to the Best Property in Every Neighborhood, Find your
            Space , your Style and Make it your Home.
          </p>
          <Btn btnText={"Get Started"} btnLink={"/auth/signup-opt"} btnClass={"home-btn"} />
        </div>
        <div className="hero-right">
          <img src={hero} alt="hero" />
        </div>
      </div>
      {/* <SearchFilter /> */}
    </div>
  );
};

export default Hero;
